<template>
  <div :class="{'friendship-activities': true, 'white-background': readOnly}">
    <div class="row title">
      <!-- Render header text only for the first element -->
      <span :class="{'header': !readOnly, 'header black': readOnly}">
        {{ $t('friendshipAdmin.activitiesTitle') }}
      </span>
      <span v-show="!isEditing && canEdit" class="edit-icon">
        <a tabindex="0" href="javascript:void(0);" @click="toggleEdit">
          <font-awesome-icon icon="pencil-alt" aria-hidden="true" />
        </a>
      </span>
    </div>
    <div v-show="!hasActivities">
      <span>{{ $t('friendshipAdmin.noActivities') }}</span>
    </div>
    <div v-show="!isEditing" :class="{'indent' : readOnly}">
      
      <div v-for="activity in groupActivities" :key="activity.$id" class="activity-item">
        <friendshipActivity
          :value="activity"
          :friend-management-group-id="friendshipManagementGroupId"
          :read-mode="true"
        />
      </div>
    </div>
    <div v-show="isEditing && canEdit">
      <div v-for="activity in groupActivities" :key="activity.$id" class="activity-item">
        <friendshipActivity
          :value="activity"
          :friend-management-group-id="friendshipManagementGroupId"
          :read-mode="false"
        />
      </div>
      <div class="col-12 buttons">
          <sprbutton type="button"
          :size="5"
        :title="$t('userAdmin.editSave')"
        class="spr-redborder primary"
        click-event="savecontact"
        @savecontact="onSave"
        />
        <sprbutton type="button"
        :size="5"
        :title="$t('userAdmin.editCancel')"
        class="spr-redborder"
        click-event="cancelsave"
        @cancelsave="onCancel"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import friendshipActivity from '@/components/useradmin/FriendshipActivity.vue'
import sprbutton from '@/components/SPRButton.vue'


export interface TemplateComponentData {
    internalList: Array<any>,
    internalValue: number,
    isEditing: boolean,
  }

export default Vue.extend({
  components: {
    friendshipActivity, sprbutton
  },
  props: {
    groupActivities: {
      type: Array<any>,
      required: true
    },
    friendshipManagementGroupId: {
      type: Number,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: false,
      default: false
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    } 
  },
  data (): TemplateComponentData {
    return {
      internalList: this.groupActivities,
      internalValue: 0,
      isEditing: false
    } as TemplateComponentData
  },
  computed: {
    hasActivities (): boolean {
      return this.groupActivities.filter(g => g.friendManagementGroupId != 0).length > 0
    }
  },
  methods: {
    onSave (): void {
      var self = this
        this.$validator.validateAll().then(result => {
          if (result) {
            self.$emit('ActivitySave')
            this.toggleEdit()
          }
        })
    },
    removeDescription(activity, index) {
      activity.descriptions.splice(index, 1);
    },
    toggleEdit (): void {
      if (this.isEditing === false) {
        this.$emit('ActivityEdit')
      }
      this.isEditing = !this.isEditing
    },
    onCancel () {
        this.toggleEdit()
        this.$emit('ActivityCancel')
      },

  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.friendship-activities {
  margin-bottom: 10px;
    .title {
      font-weight: bold;
      margin-bottom: 5px;
    }
    .contactinfoitem {
      svg {
        color:$brand-red;
        margin-right: 5px;
      }
    }

  .header,
  .edit-icon {
    display: inline-block;
    vertical-align: middle; /* Optional: Aligns elements vertically in the middle */
    color:$brand-red;
  }
  .header {
    font-weight: bold;
    margin-right: 10px;
  }
  .black {
    color:$brand-black;
    font-size: larger;
  }
  .indent {
    margin-left: 20px;
  }
  .activity-item {
    margin-bottom: 20px;
  }

  .activity-details {
    margin-left: 20px;
  }

    .few-zips {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .buttons {
      margin-bottom: 15px;
      a {
        margin-top: 20px;
        display: block;
      }

      .primary {
        color:$brand-white;
        background-color:$brand-red;

        &:hover {
          color:$brand-red;
          background-color:$brand-white;
        }
      }
    }
  }
  .white-background {
    background-color: $brand-white;
    padding: 20px;
    margin-top: -10px;
  }

</style>